'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size:14px;\n  font-family:"Open Sans", arial;\n  color:', ';\n  padding:6px;\n  margin-top:0.4em;\n  margin-bottom:0.4em;\n  \n\t&.input-error{\n\t\tborder-bottom:1px solid #ff0000 !important;\n\t}\n  \n  \n  &:disabled{\n\tborder:1px solid #a9a9a9;\n\tbackground:#ebebe4;\n\tcolor:#aaa;\n  }\n'], ['\n  font-size:14px;\n  font-family:"Open Sans", arial;\n  color:', ';\n  padding:6px;\n  margin-top:0.4em;\n  margin-bottom:0.4em;\n  \n\t&.input-error{\n\t\tborder-bottom:1px solid #ff0000 !important;\n\t}\n  \n  \n  &:disabled{\n\tborder:1px solid #a9a9a9;\n\tbackground:#ebebe4;\n\tcolor:#aaa;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iaReact = require('ia.react.colorlist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Select = _styledComponents2.default.select(_templateObject, _iaReact.COLORS.grey5);

exports.default = Select;